import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4872 6.28094L10.0627 1.85313C9.51506 1.30679 8.7733 1 8 1C7.2267 1 6.48494 1.30679 5.93734 1.85313L1.51276 6.28094C1.34967 6.44308 1.22037 6.636 1.13236 6.84851C1.04434 7.06102 0.999352 7.2889 1.00001 7.51894V13.249C1.00001 13.7134 1.18438 14.1587 1.51257 14.4871C1.84076 14.8155 2.28588 15 2.75001 15H13.25C13.7141 15 14.1592 14.8155 14.4874 14.4871C14.8156 14.1587 15 13.7134 15 13.249V7.51894C15.0006 7.2889 14.9557 7.06102 14.8676 6.84851C14.7796 6.636 14.6503 6.44308 14.4872 6.28094ZM9.75 13.8326H6.25V11.5364C6.25 11.072 6.43438 10.6266 6.76256 10.2982C7.09075 9.96986 7.53587 9.78538 8 9.78538C8.46413 9.78538 8.90925 9.96986 9.23744 10.2982C9.56562 10.6266 9.75 11.072 9.75 11.5364V13.8326ZM13.8333 13.249C13.8333 13.4038 13.7719 13.5522 13.6625 13.6617C13.5531 13.7711 13.4047 13.8326 13.25 13.8326H10.9167V11.5364C10.9167 10.7624 10.6094 10.0201 10.0624 9.47279C9.51541 8.92549 8.77355 8.61801 8 8.61801C7.22645 8.61801 6.48459 8.92549 5.93761 9.47279C5.39063 10.0201 5.08334 10.7624 5.08334 11.5364V13.8326H2.75001C2.5953 13.8326 2.44692 13.7711 2.33753 13.6617C2.22813 13.5522 2.16667 13.4038 2.16667 13.249V7.51894C2.16721 7.36425 2.22862 7.216 2.33759 7.10627L6.76217 2.6802C7.09099 2.35272 7.53605 2.16887 8 2.16887C8.46394 2.16887 8.90901 2.35272 9.23783 2.6802L13.6624 7.10802C13.771 7.21732 13.8323 7.36486 13.8333 7.51894V13.249Z"
      fill="#151718"
    />
  </svg>
);

const HomeIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default HomeIcon;
